// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2VPNB","image":"styles_image__2J6Ij"};